import user from '@/stores/user'
import { parseCookie, REQUEST_AUTH_TOKEN, REQUEST_AUTH_USERID } from '@/utils/utils'

// url获取手机号码
const useValidateApp = () => {
  const cookie = parseCookie()
  console.log('cookie', cookie)
  // cookie['FROM'] && (user.from = cookie['FROM'])
  if (cookie['FROM'] === user.from) {
    console.log('在R1_APP内', user.from)
  } else {
    return
  }
  user.token = cookie[REQUEST_AUTH_TOKEN]
  user.uid = cookie[REQUEST_AUTH_USERID]
}

export default useValidateApp
